import { useEffect, useState } from "react";
import Folder from "./FolderTree/Folder";
import SC from "./style";
import { apiGet, apiPost } from "api/callApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import OccupantNumberDropdown from "components/OccupantNumberDropdown";
import OccupantNameDropdown from "components/OccupantNameDropdown";
import { useSelector } from "react-redux";
import { Button, Loader } from "@InnoUI/";
import theme from "@theme/";
import { showAlert } from "utils/helper";
import InnoIcons from "@InnoIcons/";

const MoveFiles = (props) => {
  const { fileData, onClose } = props;

  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const [folders, setFolders] = useState([]);
  const [selectedOccupantId, setSelectedOccupantId] = useState();
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || {}
  );

  const occupantOption = useSelector(
    (state) => state?.occupantOption?.data || []
  );

  const nameOption = occupantOption.map((option) => ({
    label: option?.occupantName,
    id: option?.id,
  }));

  const numberOption = occupantOption.map((option) => ({
    label: option?.occupantNo,
    id: option?.id,
  }));

  const firstOccupantId = nameOption.length > 0 ? nameOption[0]?.id : null;

  // function to get Folder Data
  const getFolderData = async (occupantId) => {
    try {
      setLoading(true);
      const result = await apiGet(
        `/v1/projectfolder/${occupantId}/${1}`,
        false
      );

      if (result.data) {
        setFolders([...result.data]);
      }
      setLoading(false);
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
    }
  };

  const handleChangeDropdown = (property, value) => {
    setSelectedOccupantId(value);
    getFolderData(value);
    setSelectedFolderId(null);
  };

  useEffect(() => {
    const occupantId = type == 0 ? firstOccupantId : currentOccupant?.id;
    setSelectedOccupantId(occupantId);
    getFolderData(occupantId);
  }, []);

  const handleMove = async (data) => {
    if (!selectedOccupantId || !selectedFolderId) {
      showAlert({
        title: "Error",
        text: "Please select an occupant and folder",
        icon: "error",
      });
      return;
    }
    try {
      const result = await apiPost(`/v1/file/movefile`, {
        occupantId: selectedOccupantId,
        fileId: fileData.id,
        folderId: selectedFolderId,
      });
      showAlert({
        title: "Success",
        text: result.message,
        icon: "success",
      });
      // navigate(
      //   `/document?projectId=${fileData.projectId}&folderId=${fileData.folderId}&type=${type}`
      // );
      window.location.href = `/document?projectId=${fileData.projectId}&folderId=${fileData.folderId}&type=${type}`;
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleCancel = () => {
    onClose();
  };
  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>Move File</SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>
      <div style={{ padding: "15px 15px 0px 30px" }}>
        <SC.InfoRow>
          <SC.Label>File Name:</SC.Label>
          <SC.Value>{fileData.fileName || "N/A"}</SC.Value>
        </SC.InfoRow>
        <SC.InfoRow>
          <SC.Label>File Description:</SC.Label>
          <SC.Value>{fileData.subject || "N/A"}</SC.Value>
        </SC.InfoRow>
      </div>
      <SC.BodyContainer>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 15px 0px 30px",
            alignItems: "center",
          }}
        >
          <SC.Label>Move to occupant:</SC.Label>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <p style={{ fontWeight: "bold", fontSize: "13px" }}>
                Occupant by name
              </p>
              <OccupantNameDropdown
                name="occupantName"
                onChange={handleChangeDropdown}
                defaultValue={selectedOccupantId || firstOccupantId}
                nameOption={nameOption}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <p style={{ fontWeight: "bold", fontSize: "13px" }}>
                Occupant by number
              </p>
              <OccupantNumberDropdown
                name="occupantNumber"
                onChange={handleChangeDropdown}
                defaultValue={selectedOccupantId || firstOccupantId}
                numberOption={numberOption}
              />
            </div>
          </div>
        </div>
      </SC.BodyContainer>

      {loading ? (
        <Loader height={"50%"} />
      ) : (
        <>
          <SC.FolderStructureContainer>
            {folders.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  minHeight: "200px",
                }}
              >
                <p
                  style={{
                    textAlign: "center",
                  }}
                >
                  No folders found
                </p>
              </div>
            ) : (
              folders.map((folder) => (
                <Folder
                  key={folder.id}
                  folder={folder}
                  setSelectedFolderId={setSelectedFolderId}
                  selectedFolderId={selectedFolderId}
                />
              ))
            )}
          </SC.FolderStructureContainer>

          {folders.length !== 0 && (
            <SC.ButtonContainer>
              <Button
                caption="Cancel"
                onClick={handleCancel}
                fontSize="12px"
                style={{
                  marginBottom: 8,
                  background: theme.colors.cancelButton,
                  color: theme.colors.white,
                  minWidth: "90px",
                  borderRadius: "3px",
                  height: "30px",
                  fontSize: "12px",
                }}
              />
              <Button
                caption={"Move"}
                onClick={handleMove}
                color="white"
                fontSize="12px"
                style={{
                  marginBottom: 8,
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "100px",
                  height: "30px",
                  borderRadius: "3px",
                }}
              />
            </SC.ButtonContainer>
          )}
        </>
      )}
    </>
  );
};

export default MoveFiles;
